import { FiscalDocument, FiscalDocumentQuery, FiscalPrintEnabledQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsFind, useCqrsSearch } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { invoiceSharedTranslationKeys } from '../translations';

type InvoiceCreateModalRenderProps = {
   fiscalDocuments: FiscalDocument[] | undefined;
   fiscalPrintEnabled: boolean;
};

type InvoiceCreateModalLoaderProps = {
   readonly referenceId: string;
   readonly children: (renderProps: InvoiceCreateModalRenderProps) => JSX.Element;
};

export const InvoiceCreateModalLoader = (props: InvoiceCreateModalLoaderProps): JSX.Element | null => {
   const {
      data: fiscalPrintEnabled,
      error: fiscalPrintEnabledError,
      loading: fiscalPrintEnabledLoading,
   } = useCqrsFind<boolean>(() => new FiscalPrintEnabledQuery(), {
      onUnexpectedError: () => dispatchSnackbarNegativeEvent(invoiceSharedTranslationKeys.fetchError),
   });

   const {
      data: fiscalDocuments,
      error: fiscalDocumentsError,
      loading: fiscalDocumentsLoading,
   } = useCqrsSearch<FiscalDocument>(
      () => {
         const query = new FiscalDocumentQuery();
         query.referenceId = Slot.of(props.referenceId);
         return query;
      },
      undefined,
      {
         onUnexpectedError: () => dispatchSnackbarNegativeEvent(invoiceSharedTranslationKeys.fetchError),
      }
   );

   if (fiscalPrintEnabledLoading || fiscalDocumentsLoading) {
      return null;
   }

   if (fiscalPrintEnabledError || fiscalDocumentsError) {
      return null;
   }

   return props.children({
      fiscalDocuments: fiscalDocuments,
      fiscalPrintEnabled: Boolean(fiscalPrintEnabled),
   });
};
